import { GameResultContainer } from "./GameResultContainer";
import type { DailyPuzzle } from "@/lib/types/game";
import type { LogicRule } from "@/lib/game-utils";
import type { GameResult } from "@/hooks/useGameFlow";

interface GameResultViewProps {
  gameResult?: GameResult;
  currentGameResult?: GameResult;
  todaysPuzzle: DailyPuzzle | null;
  userEmail: string | null;
  filteredRules: LogicRule[];
  isUsingExternalData?: boolean;
}

export function GameResultView({
  gameResult,
  currentGameResult,
  todaysPuzzle,
  userEmail,
  filteredRules,
  isUsingExternalData = false,
}: GameResultViewProps) {
  // If we have a current result from a just-completed game, use that, otherwise fall back to passed-in gameResult
  const resultToDisplay = currentGameResult || gameResult;
  
  return (
    <GameResultContainer
      onGoBack={() => {
        // No longer allow going back to main screen - keep showing results
        console.log("Attempt to go back from results - ignoring since game is complete");
      }}
      puzzle={todaysPuzzle}
      userEmail={userEmail}
      isUsingExternalData={isUsingExternalData}
      gameResult={resultToDisplay}
      filteredRules={filteredRules}
    />
  );
}
